module.exports = "pegasus/assets/frame-twitter.png";